const CONFIG = {
  EMAIL: 'EXTRA@digisure.se',
  COLLISION_EMAIL: 'EXTRA@digisure.se',
  //FIXME: Would be fixed in next feature commit
  ADVANCE_PURCHASE_INFO_LINK:
    'https://extra.digisure.se/wp-content/uploads/Forkopsinformation-010222.pdf',
  SUPPORT_LINK: '',
  MAIN_LINK: {
    vehicle: 'http://extra.digisure.se/',
  },
  PRIVACY_POLICY_LINK: 'https://digisure.no/personuppgifter/',
  PARTNER_NAME: 'circlek',
  VIPPS_AUTH: false,
  TRANSLATION_LANGUAGES: ['sv-SE'],
  GOOGLE_RECAPTCHA_LINKS: {
    PRIVACY: 'https://policies.google.com/privacy?hl=sv',
    TERMS: 'https://policies.google.com/terms?hl=sv',
  },
  FNOL: {
    PageWindshield: {
      iconLink: 'https://booking.bilglass.no/',
    },
    PageRoadsideAssistance: {
      iconLink: 'https://rsa2.falck.no/',
    },
  },
}

export default CONFIG
